module.exports = __webpack_public_path__ + "static/donburipoulet-696208d06a11baf5b7645ccc9daabb59.jpg";